module.exports = __webpack_public_path__ + "img/自助机照片2.305db01d.png";